export function createErrorExtractor(messages) {
  const get = (fieldName, errors, translate) => {
    if (messages && errors) {
      const errorKey = typeof errors === 'string' ? errors : errors[fieldName];
      if (errorKey != null) {
        return translate(messages[fieldName][errorKey]);
      }
      return null;
    }
    return null;
  };
  return { get }
}


// WEBPACK FOOTER //
// ./src/app/modules/uq-forms/helpers.js